export default function( umbrella ) {

    function getHostname() {
        return ( window && window.location ? window.location.hostname : '' ) || '';
    }

    function isLocalhost() {
        const hostname = getHostname();
        return [ 'localhost', 'lvh.me', '127.0.0.1', '[::1]' ].includes( hostname );
    }

    let environment = window.biwEnvironment || '';
    function getEnvironment() {
        if ( !environment ) {
            if ( isLocalhost() ) {
                environment = 'qa';
            } else {
                const hostname = getHostname();
                environment = hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
                    return [ 'qa', 'pprd' ].indexOf( chunk ) >= 0;
                } );
            }
        }
        return environment;
    }

    let domain = window.biwDomain || '';
    function getDomain() {
        if ( !domain ) {
            if ( isLocalhost() ) {
                domain = 'biw.cloud';
            } else {
                const hostname = getHostname();
                const subdomains = hostname.split( '.' );
                domain = subdomains.slice( subdomains.length - 2 ).join( '.' );
            }
        }
        return domain;
    }

    function getURL( url ) {
        const env = getEnvironment();
        const domain = getDomain();

        url = url.toLowerCase();
        url = url.replace( '(env)', env ? env : ''  );
        url = url.replace( '(env.)', env ?  `${ env }.` : ''  );
        url = url.replace( '(domain)', domain );

        return url;
    }

    umbrella.isLocalhost = isLocalhost;
    umbrella.getEnvironment = getEnvironment;
    umbrella.getDomain = getDomain;
    umbrella.getURL = getURL;
}
